import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanizeKey',
  standalone: false,
})
export class HumanizeKeyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  }
}
